import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
    AdminManagedVendorState,
    InventoryRule,
    Vendor,
    ModalState,
    DistributionCenter,
} from 'admin/stores/redux/AdminManagedVendor/interfaces';

const initialState: AdminManagedVendorState = {
    initialized: false,
    vendor: null,
    rules: [],
    modalState: {
        displayModal: false,
    },
};

export const adminManagedVendorSlice = createSlice({
    name: 'adminManagedVendor',
    initialState,
    reducers: {
        init: (
            state: AdminManagedVendorState,
            action: PayloadAction<Vendor>
        ) => {
            state.initialized = true;
            state.vendor = action.payload;
        },
        replace: (
            state: AdminManagedVendorState,
            action: PayloadAction<Vendor>
        ) => {
            state.vendor = action.payload;
        },
        addDistributionCenter: (
            state: AdminManagedVendorState,
            action: PayloadAction<DistributionCenter>
        ) => {
            if (state.vendor) {
                state.vendor.distributionCenters.push(action.payload);
            }
        },
        updateDistributionCenter: (
            state: AdminManagedVendorState,
            action: PayloadAction<DistributionCenter>
        ) => {
            if (state.vendor) {
                const index = state.vendor.distributionCenters.findIndex(
                    _dc => _dc.id === action.payload.id
                );

                if (index !== -1) {
                    const updatedDistributionCenters = [
                        ...state.vendor.distributionCenters,
                    ];

                    updatedDistributionCenters.splice(index, 1, action.payload);

                    state.vendor.distributionCenters =
                        updatedDistributionCenters;
                }
            }
        },
        setRules: (
            state: AdminManagedVendorState,
            action: PayloadAction<InventoryRule[]>
        ) => {
            state.rules = action.payload;
        },
        setModalState: (
            state: AdminManagedVendorState,
            action: PayloadAction<ModalState>
        ) => {
            state.modalState = action.payload;
        },
    },
});

export const {
    init,
    replace,
    addDistributionCenter,
    updateDistributionCenter,
    setRules,
    setModalState,
} = adminManagedVendorSlice.actions;

export default adminManagedVendorSlice.reducer;
